const exampleProject= {
    link: "https://github.com/example/project1",
    title: "Project1",
    type: "",
    startDate: "2023-08-02",
    endDate: "2023-09-03",
    overview: "Tech Stack",
    github: "https://github.com/example/project1",
    points: [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris1.",
      ""
    ]
}

const exampleExperience = {
    certificationLink: "https://www.github.com/example/",
    title: "Job Title",
    startDate: "2023-09-02",
    endDate: "2023-09-29",
    companyName: "Company1",
    location: "City1",
    "points": [
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris2.",
      ""
    ]
}

const exampleEducation = {
    "title": "Degree",
    "college": "School1",
    "startDate": "2023-05-12",
    "endDate": "2023-09-14",
    "result": "Marks: dd/100"
}

const exampleSkill = {
    "title": "title1",
    "points": [
      "Skill1",
      "Skill2",
      "Skill3",
      "Skill4",
      "Skill5",
      "","","","","","","",
    ]
}

export {exampleProject, exampleExperience, exampleEducation, exampleSkill} 